import React from "react";
import NotRecord from "../../images/Clear-filter.svg";

export default function NoRecordFound(props) {
  return (
    <div id="notfound">
      <div style={{ height: "400px" }} className="notfound">
        <div className="notfound-404">
          <img style={{ width: "100%" }} src={NotRecord} />
          <p className="no-result-text">No Result Found</p>
        </div>
      </div>
    </div>
  );
}
